import React, { useEffect } from "react";
import styled from "styled-components";
import { Input } from "antd";
import { useHistory } from "react-router-dom";
import routes from "../../config/routes";
import { strings } from "../../languages/Localize";

const StyledCodeInput = styled(Input)`
    height: 50%;
    width: 75%;
    font-size: ${({ theme }) => theme.fontSizes[4]}px;
    font-weight: bold;
    text-align: center;
    color: ${({ theme }) => theme.colors.primary};
`;

const PanelCodeInput = ({ code, id, impression }) => {
    const history = useHistory();

    const onChangeHandler = event => {
        if (code === event.target.value) {
            history.push(`${routes.PANELS_IMPRESSION}${id}`);
        }
    };

    return <StyledCodeInput placeholder={strings.panel.IMPRESSION_PLACEHOLDER} type="number" onChange={onChangeHandler} />;
};

export default PanelCodeInput;
